import { render, staticRenderFns } from "./ArtistDetails.vue?vue&type=template&id=0301c7f8&scoped=true"
import script from "./ArtistDetails.vue?vue&type=script&lang=js"
export * from "./ArtistDetails.vue?vue&type=script&lang=js"
import style0 from "./ArtistDetails.vue?vue&type=style&index=0&id=0301c7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0301c7f8",
  null
  
)

export default component.exports